import React from 'react';
import {Button} from '../../basic-ui-components/button/base/button.component';
import {OrbitComponentWithState} from "../base-components/orbit-component-with-state/orbit-component-with-state";
import {observer} from "mobx-react";
import {UserInfo} from "../user-info/user-info.component";
import {UserDetailsSectionBox} from "./boxes/user-details-section.box";
import {UserDetailsWrapperBox} from "./boxes/user-details-wrapper.box";
import {UserMenuPictureBox} from "./boxes/user-menu-picture.box";
import {UserMenuTitleAccountBox} from "./boxes/user-menu-title-account.box";
import {UserMenuTitleMobileBox} from "./boxes/user-menu-title-mobile.box";
import {UserInfoLabelBox} from "../user-info/user-info-label.box";

export interface UserDetailsState {
  avatarUrl: string,
}

@observer
export class UserDetails extends OrbitComponentWithState<{}, UserDetailsState> {
  state = {
    avatarUrl: ''
  };

  componentDidMount(): void {
    super.componentDidMount();
    this._setAvatarState('regular');
  }

  render() {
    const isMobile = this.services.device.isMobile;

    return (
      <UserDetailsSectionBox className="cy-user-menu-user-details">
        <UserDetailsWrapperBox onClick={() => { isMobile && this.services.userMenu.launchMyAccount() }}>
          {this._renderAvatar()}
          {this._renderUserData()}

          { !this.services.device.isMobile &&
          <Button className="cy-user-menu-my-account-button"
            preset="info"
            onClick={() => { !isMobile && this.services.userMenu.launchMyAccount() }}
          >
            {this.services.translation.translate("MY_ACCOUNT")}
          </Button> }
        </UserDetailsWrapperBox>
      </UserDetailsSectionBox>
    );
  }

  private _setAvatarState(newState: string) {
    const config = this.services.configuration.data.generalSettings.avatarUrl.drawer;
    this.setState({avatarUrl: config[newState]});
  }

  private _renderAvatar() {
    return (<UserMenuPictureBox
      src={this.state.avatarUrl}
      onMouseEnter={() => this._setAvatarState('hover')}
      onMouseLeave={() => this._setAvatarState('regular')}
      onMouseDown={() => this._setAvatarState('pressed')}
      onMouseUp={() => this._setAvatarState('regular')}
      alt=""
    />);
  }

  private _renderUserData() {
    const translator = this.services.translation;
    return (
      <UserMenuTitleAccountBox>
        {
          this.services.device.isMobile &&
          <UserMenuTitleMobileBox>{translator.translate('MY_ACCOUNT')}</UserMenuTitleMobileBox>
        }
        <UserInfoLabelBox>{translator.translate('SUPPORT_ID_MESSAGE')}</UserInfoLabelBox>
        <UserInfo className="user-cid cy-user-cid" selectedUserInfo="cid" />
      </UserMenuTitleAccountBox>
    );
  }
}
